import React from "react";
import MultiLocationOverviewModule from "./multiLocationOverview";
import MultiLocationOverviewSagas from "./redux/multiLocationOverviewSaga";
import MultiLocationOverviewReducer from "./redux/multiLocationOverviewReducer";
import PageWithConfigurator from "../../shared/pageWithConfigurator/pageWithConfigurator";

const pageConfig = {
  pageName: "Multi Location Overview",
  moduleList: [
    {
      Component: MultiLocationOverviewModule,
      moduleName: "multiLocationOverview",
      saga: MultiLocationOverviewSagas(),
      reducer: MultiLocationOverviewReducer
    }
  ],
  hideConfigurator: true
};

const multiLocationOverviewPage = ({ notifications }) => {
  return <PageWithConfigurator pageConfig={pageConfig} notifications={notifications} />;
};

export default multiLocationOverviewPage;
